/* src/app/global/components/global-help/global-help-lists/global-help-lists.component.scss */
:host .cw-module-card {
  padding: 20px;
}
:host mat-panel-title {
  line-height: 1.6rem;
  margin-right: 0;
  max-width: 100%;
  min-height: 1em;
  overflow: hidden;
  overflow-wrap: break-word;
}
:host mat-panel-title > .cw-expansion-panel-title {
  display: block;
  max-width: 100%;
}
:host ::ng-deep .mat-expansion-panel-header {
  color: inherit;
  cursor: pointer;
  padding: 12px 24px;
}
:host ::ng-deep .mat-expansion-panel {
  border-radius: 0;
}
:host .cw-toolbar-icon:not(:hover) {
  border: 1px solid transparent;
}
/*# sourceMappingURL=global-help-lists.component.css.map */
